/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Picker from 'emoji-picker-react';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import LabelLibrary from 'app/components/PostingTool/LabelLibrary.js';
import PostToolUploader from 'app/components/PostingTool/PostToolUploader.jsx';
import TextareaEvents from 'app/components/PostingTool/TextareaEvents.js';
import ThumbnailPreview from 'app/components/PostingTool/ThumbnailPreview.jsx';
import LinkPreview from 'app/components/PostingTool/LinkPreview.jsx';
import GoogleSchedule from 'app/components/PostingTool/GoogleSchedule.jsx';
import PostSocialButton from 'app/components/PostingTool/PostSocialButton.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import MediaSourceMenu from 'app/components/PostingTool/MediaSourceMenu.jsx';
import HashtagGenerator from 'app/components/PostingTool/Accessories/HashtagGenerator.jsx';
import TagInput from 'app/components/common/TagInput.jsx';
import YouTubePlaylistChooser from 'app/components/PostingTool/Accessories/YouTubePlaylistChooser.jsx';

class ServiceFields extends React.Component {
    constructor(props) {
        super(props);

        let constants = this.props.app.config.constants;

        this.state = {
            isEmojiPickerVisible: false,
            tikTokDisclosure: false,
            youtubeCategoriesLoaded: false,
            isHashtagSelectorVisible: false
        };

        this.keyUpPasteFlag = false;
        this.keyUpTimeout = 0;
        this.instanceName = "ServiceFields";

        this.messageRef = React.createRef();
        this.emojiPickerRef = React.createRef();
        this.fieldGenerator = this.fieldGenerator.bind(this);
        this.interactionCheck = this.interactionCheck.bind(this);
        this.toggleEmojiPicker = this.toggleEmojiPicker.bind(this);
        this.toggleTikTokDisclosure = this.toggleTikTokDisclosure.bind(this);
        this.setDropzoneRef = this.setDropzoneRef.bind(this);
        this.toggleHashtagSelector = this.toggleHashtagSelector.bind(this);
        this.toggleFacebookMediaOptions = this.toggleFacebookMediaOptions.bind(this);
        this.mediaChecker = this.mediaChecker.bind(this);

    }

    componentDidMount() {

        document.addEventListener('mouseup', this.interactionCheck);
        document.addEventListener('touchend', this.interactionCheck);

        let constants = this.props.app.config.constants;
        if (parseInt(this.props.serviceType) === constants.POST_SVC_YOUTUBE) {
            let id = this.props.selectedSocials[constants.POST_SVC_YOUTUBE][0];
            if (Object.keys(this.props.socials.categories).length === 0) {
                this.props.getYouTubeCategories(id);
            }
            if (this.props.socials.playlists[id] === undefined) {
                this.props.getYouTubePlaylists(id);
            }
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let constants = this.props.app.config.constants;

        if (prevProps && prevProps.app.loading.SOCIAL_GET_CATEGORIES === true && this.props.app.loading.SOCIAL_GET_CATEGORIES === false) {
            this.setState({
                youtubeCategoriesLoaded: true
            });
        }

        if (prevProps && prevProps.postData !== undefined) {
            if (prevProps.postData.message && this.messageRef.current) {
                this.messageRef.current.value = this.props.postData.message;
            }
        }

        if (parseInt(this.props.serviceType) === constants.POST_SVC_YOUTUBE) {
            if (prevProps.selectedSocials[constants.POST_SVC_YOUTUBE][0] !== this.props.selectedSocials[constants.POST_SVC_YOUTUBE][0]) {
                this.props.getYouTubePlaylists(this.props.selectedSocials[constants.POST_SVC_YOUTUBE][0]);
            }
        }

    }

    componentWillUnmount() {

        document.removeEventListener('mouseup', this.interactionCheck);
        document.removeEventListener('touchend', this.interactionCheck);

    }

    interactionCheck(e) {
        if (this.state.isEmojiPickerVisible) {
            if (this.emojiPickerRef.current && this.emojiPickerRef.current.contains(e.target)) {
                return;
            }
            this.setState({
                isEmojiPickerVisible: false
            });
        }
    }

    setDropzoneRef(ref) {
        this.setState({
            dropzoneRef: ref
        });
    }

    fieldGenerator(key) {
        let fieldInfo = this.props.serviceInfo.fields[key],
            field = null,
            type = this.props.serviceType,
            postData = null,
            validator = this.props.posts.postValidators[type],
            validationErrors = this.props.validationErrors[type] || null,
            mediaErrors = this.props.mediaErrors[type] || null,
            hasError = false,
            hasImageError = false,
            errorClass = '',
            imageErrorClass = '',
            constants = this.props.app.config.constants,
            mediaSourceOptions = [];

        if (this.props.postData !== undefined) {
            postData = this.props.postData;
        }

        this.props.mediaSourceOptions.map((sourceOption) => {
            let option = Object.assign({}, sourceOption);

            switch (option.key) {
                case 'upload':
                    option.action = () => {
                        this.props.showMediaEditor('mediaUploader', this.props.serviceType);
                    };
                    break;

                case 'unsplash':
                    option.action = () => {
                        this.props.showMediaEditor('galleryChooser', this.props.serviceType);
                    };
                    break;

            }

            mediaSourceOptions.push(option);

        });

        let categoryButtonClass = "tt-button tag-button",
            categoryName = '';
        if (postData.tagID !== undefined && postData.tagID) {
            categoryButtonClass += " active";
            if (postData.tagName) {
                categoryName = postData.tagName;
            }
        }

        const hashtagCallback = (tag, action, service) => {
            let message = this.props.onHashtagSelect(tag, action, service);

            if (this.messageRef.current) {
                this.messageRef.current.value = message;
            }

        };

        let hashtagButtonClass = 'tt-button hashtags',
            hashtagSelector = null;
        if (this.state.isHashtagSelectorVisible) {
            hashtagButtonClass += ' active';
            hashtagSelector = (
                <HashtagGenerator
                    {...this.props}
                    postData={postData}
                    onHashtagSelect={hashtagCallback}
                    service={this.props.serviceType}/>
            );
        }

        const emojiCallback = (e, emoji) => {
            if (this.messageRef.current) {
                let startPos = this.messageRef.current.selectionStart,
                    endPos = this.messageRef.current.selectionEnd,
                    inputChange = {
                    currentTarget: {
                        dataset: {
                            field: `postData.services.${this.props.serviceType}.message`
                        }
                    },
                    target: {
                        value: ''
                    }
                };

                inputChange.target.value = `${this.messageRef.current.value.substring(0, startPos)} ${emoji.emoji} ${this.messageRef.current.value.substring(endPos, this.messageRef.current.value.length)}`;

                this.props.requestChange(inputChange);

                this.messageRef.current.value = inputChange.target.value;
            }
        }

        if (fieldInfo) {
            if (validationErrors !== null && validationErrors[key] !== undefined && validationErrors[key]) {
                hasError = true;
                errorClass = 'error';
            }

            // since mb_id is output with the message field check for any errors specifically instead of
            // waiting for the loop
            if (key === 'message' && mediaErrors !== null && mediaErrors.mb_id !== undefined && mediaErrors.mb_id) {
                hasImageError = true;
            }

            switch (fieldInfo.type) {
                case 'form_name':
                    return field;

                case 'url':
                    // only show the url field for specific services
                    if ((parseInt(this.props.serviceType) === constants.POST_SVC_GMYBUSINESS &&
                        postData.cta_type !== undefined && ['ACTION_TYPE_UNSPECIFIED', 'CALL'].indexOf(postData.cta_type) === -1) ||
                        (parseInt(this.props.serviceType) === constants.POST_SVC_REDDIT && postData.form !== undefined && postData.form === 'link_post') ||
                        [constants.POST_SVC_SLACK, constants.POST_SVC_PINTEREST, constants.POST_SVC_TUMBLR].indexOf(parseInt(this.props.serviceType)) !== -1) {
                        if ([constants.POST_SVC_SLACK, constants.POST_SVC_REDDIT, constants.POST_SVC_PINTEREST, constants.POST_SVC_TUMBLR].indexOf(parseInt(this.props.serviceType)) !== -1) {
                            let linkLoader = null;
                            if (postData[key] && this.props.linkPreviews[postData[key]] === undefined) {
                                linkLoader = (
                                    <div className="link-field-loader">
                                        <div className="working">
                                            <i className="fa fa-circle-o-notch fa-spin"></i>
                                        </div>
                                    </div>
                                );
                            }
                            field = (
                                <div className={`link-field service-${key}`}>
                                    <div className="pt-field-label">{LabelLibrary.getStringsForField(this.props.serviceType, key, 'placeholder')}</div>
                                    {linkLoader}
                                    <UncontrolledTextInput
                                        className={`text-input large ${errorClass}`}
                                        value={postData[key] !== undefined ? postData[key] : ''}
                                        name={key}
                                        onChange={this.props.requestChange}
                                        data-field={`postData.services.${type}.${key}`}
                                        data-servicetype={this.props.serviceType}
                                        onPaste={TextareaEvents.onTextareaPaste.bind(this)}
                                        onKeyUp={TextareaEvents.onTextareaKeyUp.bind(this)}/>
                                </div>
                            );
                        } else {
                            field = (
                                <div className={`service-${key}`}>
                                    <div className="pt-field-label">{LabelLibrary.getStringsForField(this.props.serviceType, key, 'placeholder')}</div>
                                    <UncontrolledTextInput
                                        className={`text-input large ${errorClass}`}
                                        value={postData[key] !== undefined ? postData[key] : ''}
                                        onChange={this.props.requestChange}
                                        data-field={`postData.services.${type}.${key}`}/>
                                </div>
                            );
                        }
                    }
                    return field;

                case 'attachment':
                    if ((parseInt(type) === constants.POST_SVC_REDDIT && postData.form === 'image_post') ||
                        (parseInt(type) === constants.POST_SVC_SNAPCHAT && postData.form === 'story') ||
                        ([constants.POST_SVC_TIKTOK, constants.POST_SVC_YOUTUBE].indexOf(parseInt(type)) !== -1)) {
                        if ((postData.imageLink !== undefined && postData.imageLink) &&
                            (postData.mb_id === undefined || !postData.mb_id)) {
                            return (
                                <ThumbnailPreview
                                    {...this.props}
                                    serviceType={this.props.serviceType}
                                    hasError={hasImageError}
                                    imageLink={postData.imageLink}
                                    editMode='network'/>
                            );
                        } else if ((postData.imageLink === undefined || !postData.imageLink) &&
                                    (postData.mb_id === undefined || !postData.mb_id) &&
                                    (postData.hashes === undefined || postData.hashes.length === 0)) {
                            return (
                                <PostToolUploader
                                    serviceType={this.props.serviceType}
                                    context="service"
                                    hasError={hasImageError}
                                    postData={postData}
                                    {...this.props}/>
                            );
                        } else {
                            let mb_id  = (postData.mb_id !== undefined && postData.mb_id) ? postData.mb_id : 0,
                                hashes = (postData.hashes !== undefined && postData.hashes.length) ? postData.hashes : [];
                            return (
                                <ThumbnailPreview
                                    {...this.props}
                                    serviceType={this.props.serviceType}
                                    mb_id={mb_id}
                                    hashes={hashes}
                                    hasError={hasImageError}
                                    editMode='network'/>
                            );
                        }
                    }
                    break;

                case 'text':
                    if (key === 'message') {
                        let serviceImage = null,
                            linkAlert = null;

                        if (parseInt(type) !== constants.POST_SVC_REDDIT) {
                            let hashes = (postData && postData.hashes !== undefined && postData.hashes.length) ? postData.hashes: [],
                                mb_id = (postData && postData.mb_id !== undefined && postData.mb_id) ? postData.mb_id : 0;

                            if (postData !== undefined && (postData.mb_id !== undefined && postData.mb_id || postData.hashes !== undefined && postData.hashes.length)) {
                                serviceImage = (
                                    <ThumbnailPreview
                                        {...this.props}
                                        hasError={hasImageError}
                                        hashes={hashes}
                                        mb_id={mb_id}
                                        editMode='network'/>
                                );
                            }  else if (postData.imageLink !== undefined && postData.imageLink) {
                                if (parseInt(type) === constants.POST_SVC_TWITTER) {
                                    let twitterLink = this.props.linkPreviews[this.props.postData.link];
                                    if (twitterLink && twitterLink.twitter_preview !== undefined && twitterLink.twitter_preview === true) {
                                        serviceImage = (
                                            <PostToolUploader
                                                context="service"
                                                serviceType={this.props.serviceType}
                                                postData={postData}
                                                hasError={hasImageError}
                                                {...this.props}
                                                editMode='network'/>
                                        );
                                    } else {
                                        serviceImage = (
                                            <ThumbnailPreview
                                                {...this.props}
                                                hasError={hasImageError}
                                                imageLink={postData.imageLink}
                                                editMode='network'/>
                                        );
                                    }
                                } else {
                                    serviceImage = (
                                        <ThumbnailPreview
                                            {...this.props}
                                            hasError={hasImageError}
                                            imageLink={postData.imageLink}
                                            editMode='network'/>
                                    );
                                }

                            } else if (validator.fields['mb_id'] !== undefined) {
                                serviceImage = (
                                    <PostToolUploader
                                        serviceType={this.props.serviceType}
                                        context="service"
                                        postData={postData}
                                        hasError={hasImageError}
                                        {...this.props}/>
                                );
                            }
                        }

                        // RSS Output? NO IMAGE FOR YOU!!
                        if (parseInt(type) === constants.POST_SVC_FEED) {
                            serviceImage = null;
                        }

                        if ([constants.POST_SVC_TWITTER, constants.POST_SVC_MASTODON].indexOf(parseInt(type)) !== -1) {
                            if (postData.link) {
                                linkAlert = <span style={{"fontSize": "0.7em"}}>(with link)</span>;
                            }
                        }

                        let aiHelperButton = null;
                        if (postData.message !== undefined && postData.message.trim() !== '') {
                            aiHelperButton = (
                                <div className={"tt-button ai-helper"} role="button" aira-label="Edit content with AI" onClick={() => {
                                    this.props.showAIHelper('prompted', type);
                                }}>
                                    <i className="icon ion-ios-color-wand"/> <div className="new-tag">Edit with AI</div>
                                </div>
                            );
                        }

                        return (
                            <div className="service-message">
                                <Breakpoint desktop only>
                                    <div className="message-group">
                                        <textarea
                                            ref={this.messageRef}
                                            className={`text-area large ${errorClass}`}
                                            placeholder={"What would you like to share?"}
                                            defaultValue={postData.message ? postData.message : ''}
                                            onChange={this.props.requestChange}
                                            data-field={`postData.services.${this.props.serviceType}.message`}
                                            data-servicetype={this.props.serviceType}
                                            onPaste={TextareaEvents.onTextareaPaste.bind(this)}
                                            onKeyUp={TextareaEvents.onTextareaKeyUp.bind(this)}>
                                        </textarea>
                                        {serviceImage}
                                    </div>
                                    <div className="service-message-controls">
                                        <div className="text-tools">
                                            <div className="tt-button media-source-chooser">
                                                <MediaSourceMenu
                                                    {...this.props}
                                                    mediaSourceOptions={mediaSourceOptions}/>
                                            </div>
                                            <div className={`tt-button text-count ${errorClass}`}>
                                                {postData.message ? this.props.getCharCount(postData.message, this.props.serviceType) : 0} {linkAlert}
                                            </div>
                                            <div className="tt-button emoji-button" role="button" aria-label="Add emojis" onClick={this.toggleEmojiPicker}>
                                                <i className="fa fa-smile-o"></i>
                                                {(this.state.isEmojiPickerVisible) ? (
                                                    <div className="pt-picker-wrapper" ref={this.emojiPickerRef}>
                                                        <Picker
                                                            onEmojiClick={emojiCallback}
                                                            native={true}/>
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className={categoryButtonClass}
                                                role="button"
                                                aria-label="Choose Category"
                                                title={categoryName}
                                                data-serviceid={this.props.serviceType}
                                                onClick={this.props.showCategoryPicker}>
                                                <i className="icon ion-ios-pricetag"></i>
                                            </div>
                                            <div className={hashtagButtonClass}
                                                role="button"
                                                aira-label="Add generated hashtags to message"
                                                onClick={this.toggleHashtagSelector}>
                                                <i className="icon ion-pound"/>
                                            </div>
                                            {aiHelperButton}
                                        </div>
                                    </div>
                                    {hashtagSelector}
                                </Breakpoint>
                                <Breakpoint mobile only>
                                    <div className="message-group-mobile">
                                        <textarea
                                            ref={this.messageRef}
                                            className={`text-area large ${errorClass}`}
                                            placeholder={"What would you like to share?"}
                                            defaultValue={postData.message ? postData.message : ''}
                                            onChange={this.props.requestChange}
                                            data-field={`postData.services.${this.props.serviceType}.message`}
                                            data-servicetype={this.props.serviceType}
                                            onPaste={TextareaEvents.onTextareaPaste.bind(this)}
                                            onKeyUp={TextareaEvents.onTextareaKeyUp.bind(this)}>
                                        </textarea>
                                        <div className="service-message-controls">
                                            <div className="text-tools">
                                                <div className="tt-button media-source-chooser">
                                                    <MediaSourceMenu
                                                        {...this.props}
                                                        mediaSourceOptions={mediaSourceOptions}/>
                                                </div>
                                                <div className={`tt-button text-count ${errorClass}`}>
                                                    {postData.message ? this.props.getCharCount(postData.message, this.props.serviceType) : 0} {linkAlert}
                                                </div>
                                                <div className="tt-button emoji-button" role="button" aria-label="Add emojis" onClick={this.toggleEmojiPicker}>
                                                    <i className="fa fa-smile-o"></i>
                                                    {(this.state.isEmojiPickerVisible) ? (
                                                        <div className="pt-picker-wrapper" ref={this.emojiPickerRef}>
                                                            <Picker
                                                                onEmojiClick={emojiCallback}
                                                                native={true}/>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className={categoryButtonClass}
                                                    role="button"
                                                    aria-label="Choose Category"
                                                    title={categoryName}
                                                    data-serviceid={this.props.serviceType}
                                                    onClick={this.props.showCategoryPicker}>
                                                    <i className="icon ion-ios-pricetag"></i>
                                                </div>
                                                <div className={hashtagButtonClass}
                                                    role="button"
                                                    aira-label="Add generated hashtags to message"
                                                    onClick={this.toggleHashtagSelector}>
                                                    <i className="icon ion-pound"/>
                                                </div>
                                                {aiHelperButton}
                                            </div>
                                        </div>
                                    </div>
                                    {hashtagSelector}
                                    <div className="image-block-mobile">
                                        {serviceImage}
                                    </div>
                                </Breakpoint>
                            </div>
                        );
                    } else {
                        return (
                            <div className={`service-${key}`}>
                                <div className="pt-field-label">{LabelLibrary.getStringsForField(this.props.serviceType, key, 'placeholder')}</div>
                                <UncontrolledTextInput
                                    className={`text-input large ${errorClass}`}
                                    value={postData[key] !== undefined ? postData[key] : ''}
                                    onChange={this.props.requestChange}
                                    data-field={`postData.services.${type}.${key}`}/>
                            </div>
                        );
                    }
                    break;

                case 'enum':
                    let options = [],
                        value = '';

                    let defaultLabel = LabelLibrary.getStringsForField(type, key, 'defaultSelect');

                    if (defaultLabel) {
                        options.push({label: defaultLabel, value: ''});
                    }

                    this.props.serviceInfo.fields[key].values.map((value, i) => {
                        let label = this.props.serviceInfo.fields[key].labels[i];
                        options.push({value, label});
                    });

                    if (postData[key] !== undefined) {
                        value = postData[key];
                    }

                    return (
                        <div>
                            <div className="pt-field-label">{LabelLibrary.getStringsForField(this.props.serviceType, key, 'placeholder')}</div>
                            <StyledSelect
                                value={value}
                                linkedField={`postData.services.${type}.${key}`}
                                onChange={this.props.requestChange}
                                options={options}
                                selectClass="med pt"/>
                        </div>

                    );
                    break;

                case 'custom':
                    if (parseInt(this.props.serviceType) === constants.POST_SVC_GMYBUSINESS) {
                        return (
                            <GoogleSchedule
                                {...this.props}/>
                        );
                    }
                    break;

                default:
                    return field;
            }
        }
    }

    toggleEmojiPicker(e) {

        if (this.emojiPickerRef.current && this.emojiPickerRef.current.contains(e.target)) {
            return;
        }

        this.setState({
            isEmojiPickerVisible: (this.state.isEmojiPickerVisible) ? false : true
        });

    }

    toggleTikTokDisclosure(e) {
        e.preventDefault();

        let nextState = e.currentTarget.dataset.togglestate === "true" ? false : true;

        this.setState({
            tikTokDisclosure: nextState
        });

    }

    toggleHashtagSelector(e) {

        this.setState({
            isHashtagSelectorVisible: (this.state.isHashtagSelectorVisible) ? false : true
        });

    }

    toggleFacebookMediaOptions(e) {
        let field = e.currentTarget.dataset.field,
            nextState = (e.currentTarget.dataset.togglestate === "true") ? false : true,
            nextPublishAsStory = (this.props.postData.publishAsStory !== undefined) ? this.props.postData.publishAsStory : false,
            nextPublishAsReel = (this.props.postData.publishAsReel !== undefined) ? this.props.postData.publishAsReel : false;

        if (field.match("publishAsStory")) {
            nextPublishAsStory = nextState;
            nextPublishAsReel = false;
        }

        if (field.match("publishAsReel")) {
            nextPublishAsReel = nextState;
            nextPublishAsStory = false;
        }

        this.props.requestChange({
            currentTarget: {
                dataset: {
                    field: 'postData.services.2.publishAsStory'
                }
            },
            target: {
                value: nextPublishAsStory
            }
        });

        this.props.requestChange({
            currentTarget: {
                dataset: {
                    field: 'postData.services.2.publishAsReel'
                }
            },
            target: {
                value: nextPublishAsReel
            }
        });

    }

    mediaChecker(types) {
        let typesToDetect = [...types];

        this.props.mediaThumbs.map((thumb) => {
            if (thumb.type.match(/image/) && typesToDetect.indexOf('image') !== -1) {
               typesToDetect.splice(typesToDetect.indexOf('image'), 1);
            } else if (thumb.type.match(/video/) && typesToDetect.indexOf('video') !== -1) {
                typesToDetect.splice(typesToDetect.indexOf('video'), 1);
            }
        });

        return (typesToDetect.length < types.length) ? true : false;
    }

    render() {
        let ServiceIcon = null,
            iconIndex = 0,
            headerFields = null,
            linkPreview = null,
            infoDisplay = null,
            apiErrorDisplay = null,
            errorDisplay = null,
            infoMessages = [],
            constants = this.props.app.config.constants,
            postData = this.props.postData,
            formFields = [],
            fieldOrder = [
                'message',
                'mb_id',
                'title',
                'sentiment',
                'alert_type',
                'schedule',
                'cta_type',
                'link',
                'body',
                'couponCode',
                'termsConditions',
                'video_title',
                'video_description',
                'privacy_status',
                'license'
            ],
            serviceType = parseInt(this.props.serviceType),
            tikTokFields = null;

        // we could be in a loading state, return null until safe
        if (this.props.serviceInfo === undefined || this.props.postData === undefined) {
            return null;
        }

        const gatherFields = (formKey) => {
            let fields = [],
                fieldNames = [],
                validator = this.props.posts.postValidators[this.props.serviceType],
                form = validator.forms[formKey],
                formKeys = Object.keys(validator.forms);

            Object.keys(form).map((key) => {
                if (_.isArray(form[key])) {
                    fieldNames = fieldNames.concat(form[key]);
                } else if (_.isObject(form[key])) {
                    if (form[key].any !== undefined) {
                        fieldNames = fieldNames.concat(form[key].any);
                    }
                    if (form[key].all !== undefined) {
                        fieldNames = fieldNames.concat(form[key].all);
                    }
                }
            });

            fieldNames.map((field) => {
                if (formKeys.indexOf(field) !== -1) {
                    fields = fields.concat(gatherFields(field));
                } else {
                    fields.push(field);
                }
            });

            return _.uniq(fields);

        };

        if (serviceType) {
            let code = ConstantMixin.getIconIndexByCode(serviceType);
            ServiceIcon = IconFactory[code];
        }

        // for services that have defined forms (google at the moment)
        if (postData && postData.form !== undefined) {
            formFields = gatherFields(postData.form)
        } else {
            formFields = Object.keys(this.props.serviceInfo.fields);
        }

        if (this.props.postData !== undefined &&
            this.props.postData.link !== undefined &&
            this.props.postData.link !== '' &&
            (this.props.postData.mb_id === undefined || !this.props.postData.mb_id) &&
            (this.props.postData.hashes !== undefined && this.props.postData.hashes.length === 0)) {
            if (this.props.isLinkLoading && this.props.linklessServices.indexOf(serviceType) === -1) {
                linkPreview = (
                    <LinkPreview
                        {...this.props}
                        loading={true}
                        context={'network'}/>
                );
            } else {
                if (this.props.linklessServices.indexOf(serviceType) !== -1) {
                    if (serviceType === constants.POST_SVC_TWITTER) {
                        let twitterLink = this.props.linkPreviews[this.props.postData.link];
                        if (twitterLink && twitterLink.twitter_preview !== undefined && twitterLink.twitter_preview === true) {
                            // preview will show a remove control if the link isn't part of the message
                            let linkInMessage = this.props.postData.message.includes(this.props.postData.link);
                            linkPreview = (
                                <LinkPreview
                                    {...this.props}
                                    loading={false}
                                    linkInMessage={linkInMessage}
                                    postData={this.props.postData}
                                    previewData={this.props.linkPreviews[this.props.postData.link]}
                                    context={'network'}
                                    removeLink={this.props.removeLink}/>
                            );
                        } else {
                            infoMessages.push(`${ConstantMixin.getPostServiceNameByCode(this.props.serviceType)} does not support link previews on sites without Twitter Cards.`);
                        }
                    } else if (serviceType === constants.POST_SVC_BLUESKY) {
                        let linkInMessage = this.props.postData.message.includes(this.props.postData.link);
                        linkPreview = (
                            <LinkPreview
                                {...this.props}
                                loading={false}
                                linkInMessage={linkInMessage}
                                postData={this.props.postData}
                                previewData={this.props.linkPreviews[this.props.postData.link]}
                                context={'network'}
                                removeLink={this.props.removeLink}/>
                        );
                    } else if ([constants.POST_SVC_REDDIT, constants.POST_SVC_SLACK].indexOf(serviceType) === -1) {
                        infoMessages.push(`${ConstantMixin.getPostServiceNameByCode(this.props.serviceType)} does not support link previews.`);
                    }

                } else {
                    linkPreview = (
                        <LinkPreview
                            {...this.props}
                            loading={false}
                            previewData={this.props.linkPreviews[this.props.postData.link]}
                            context={'network'}
                            removeLink={this.props.removeLink}/>
                    );
                }

            }

            if (serviceType === constants.POST_SVC_REDDIT && this.props.postData.form !== 'link_post') {
                // null out the link preview for reddit if the post type isn't right
                linkPreview = null;
            }
        }

        const outputError = (error, key) => {
            let errors = [];

            if (_.isObject(error)) {
                let errorKeys = Object.keys(error);
                errorKeys.map((errorKey) => {
                    errors = errors.concat(outputError(error[errorKey], errorKey));
                });

            } else {
                errors.push(
                    <li key={`error-${this.props.serviceType}-${key}`} className="post-error">
                        <i className="icon ion-android-alert"></i>{error}
                    </li>
                );
            }
            return errors;
        }

        if ((this.props.apiErrors[this.props.serviceType] !== undefined &&
            Object.keys(this.props.apiErrors[this.props.serviceType]).length) ||
            (this.props.validationErrors[this.props.serviceType] !== undefined &&
            Object.keys(this.props.validationErrors[this.props.serviceType]).length) || (
             this.props.mediaErrors !== undefined && Object.keys(this.props.mediaErrors).length
            )) {
            errorDisplay = (
                <ul className="pt-service-errors">
                    {(this.props.apiErrors[this.props.serviceType]) ? (
                        Object.keys(this.props.apiErrors[this.props.serviceType]).map((key) => {
                            return outputError(this.props.apiErrors[this.props.serviceType][key], key);
                        })
                    ) : null}
                    {(this.props.validationErrors[this.props.serviceType]) ? (
                        Object.keys(this.props.validationErrors[this.props.serviceType]).map((key) => {
                            return outputError(this.props.validationErrors[this.props.serviceType][key], key);
                        })
                    ) : null}
                    {(_.isArray(this.props.mediaErrors[this.props.serviceType]) || _.isObject(this.props.mediaErrors[this.props.serviceType])) ? (
                        Object.keys(this.props.mediaErrors[this.props.serviceType]).map((key) => {
                            return outputError(this.props.mediaErrors[this.props.serviceType][key], key);
                        })
                    ) : null}
                    {(_.isString(this.props.mediaErrors[this.props.serviceType])) ? (
                        outputError(this.props.mediaErrors[this.props.serviceType], this.props.serviceType)
                    ) : null}
                </ul>
            );
        }

        if ([constants.POST_SVC_INSTAGRAM_BUSINESS, constants.POST_SVC_FACEBOOK].indexOf(serviceType) !== -1) {
            if (postData.publishAsStory !== undefined && postData.publishAsStory && postData.message.trim().length) {
                infoMessages.push(`${ConstantMixin.getPostServiceNameByCode(this.props.serviceType)} will not publish your text with your story.`);
            }
        }

        if (infoMessages.length) {
            infoDisplay = (
                <ul className="pt-service-info">
                    {infoMessages.map((info) => {
                        return (
                            <li key={`info-${this.props.serviceType}`} className="post-info">
                                {info}
                            </li>
                        );
                    })}
                </ul>
            );
        }

        let postOptions = [],
            typeValue = '';

        if (parseInt(this.props.serviceType) === constants.POST_SVC_GMYBUSINESS) {
            postOptions = [
                {value: 'STANDARD', label: 'Update'},
                {value: 'EVENT', label: 'Event'},
                {value: 'OFFER', label: 'Offer'},
                {value: 'ALERT', label: 'Alert'},
            ];
            typeValue = 'STANDARD';

            if (postData !== undefined && postData.form !== undefined) {
                typeValue = postData.form;
            }

            headerFields = (
                <div className="post-type-selector">
                    Google Business Post Type
                    <StyledSelect
                        value={typeValue}
                        onChange={this.props.requestChange}
                        options={postOptions}
                        linkedField={`postData.services.${this.props.serviceType}.form`}
                        selectClass="small gmb"/>
                </div>
            );
        } else if (parseInt(this.props.serviceType) === constants.POST_SVC_REDDIT) {
            postOptions = [
                {value: 'text_post', label: 'Post'},
                {value: 'image_post', label: 'Media'},
                {value: 'link_post', label: 'Shared Link'}
            ];
            typeValue = 'text_post';

            if (postData !== undefined && postData.form !== undefined) {
                typeValue = postData.form;
            }

            headerFields = (
                <div className="post-type-selector reddit">
                    Reddit Post Type
                    <StyledSelect
                        value={typeValue}
                        onChange={this.props.requestChange}
                        options={postOptions}
                        linkedField={`postData.services.${this.props.serviceType}.form`}
                        selectClass="small reddit"/>
                </div>
            );
        } else if (parseInt(this.props.serviceType) === constants.POST_SVC_SNAPCHAT) {
            postOptions = [
                {value: 'story', label: 'Story Post'},
                {value: 'spotlight', label: 'Spotlight Post'}
            ];
            typeValue = 'story';

            if (postData !== undefined && postData.form !== undefined) {
                typeValue = postData.form;
            }

            headerFields = (
                <div className="post-type-selector snapchat">
                    Snapchat Post Type
                    <StyledSelect
                        value={typeValue}
                        onChange={this.props.requestChange}
                        options={postOptions}
                        linkedField={`postData.services.${this.props.serviceType}.form`}
                        selectClass="small snapchat"/>
                </div>
            );
        }

        if (parseInt(this.props.serviceType) === constants.POST_SVC_TIKTOK) {
            let disclosureFields = null,
                disclosureWarning = null;

            if (this.state.tikTokDisclosure) {
                if (postData.brand_content_toggle === true && postData.brand_organic_toggle === false) {
                    disclosureWarning = (
                        <ul className="pt-service-info">
                            <li className="post-info">
                                Your photo/video will be labeled as 'Promotional content'
                            </li>
                        </ul>
                    );
                } else if (postData.brand_organic_toggle === true)  {
                    disclosureWarning = (
                        <ul className="pt-service-info">
                            <li className="post-info">
                                Your photo/video will be labeled as 'Paid partnership'
                            </li>
                        </ul>
                    );
                } else {
                    disclosureWarning = (
                        <ul className="pt-service-info">
                            <li className="post-info">
                                You must choose what kind of content your video presents.
                            </li>
                        </ul>
                    );
                }
                disclosureFields = (
                    <div>
                        {disclosureWarning}
                        <div className="pt-inline-checkbox stacked">
                            <input
                                id="tiktok-brand"
                                type="checkbox"
                                checked={(postData.brand_content_toggle) ? true : false}
                                onChange={this.props.requestChange}
                                data-field={`postData.services.${this.props.serviceType}.brand_content_toggle`}
                                data-disclosure={'brand_content_toggle'}/>
                            <label htmlFor="tiktok-brand">Your Brand <HelpButton which="TTBrandDisclosure"/></label>
                        </div>
                        <div className="pt-inline-checkbox stacked">
                            <input
                                id="tiktok-branded"
                                type="checkbox"
                                checked={(postData.brand_organic_toggle) ? true : false}
                                onChange={this.props.requestChange}
                                data-field={`postData.services.${this.props.serviceType}.brand_organic_toggle`}
                                data-disclosure={'brand_organic_toggle'}/>
                            <label htmlFor="tiktok-branded">Branded Content <HelpButton which="TTBrandedContentDisclosure"/></label>
                        </div>
                        <div className="pt-tiktok-legal">
                            By posting, you agree to TikTok's <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank">Music Usage Confirmation</a>
                        </div>
                    </div>
                );
            }

            tikTokFields = (
                <div className="pt-service-field">
                    <div className="pt-special-header">Allow users to</div>
                    <div className="pt-inline-checkboxes">
                        <div className="pt-inline-checkbox">
                            <input
                                id="tiktok-comment"
                                type="checkbox"
                                checked={(postData.disable_comment) ? true : false}
                                onChange={this.props.requestChange}
                                data-field={`postData.services.${this.props.serviceType}.disable_comment`}/>
                            <label htmlFor="tiktok-comment">Disable Comment</label>
                        </div>
                        <div className="pt-inline-checkbox">
                            <input
                                id="tiktok-duet"
                                type="checkbox"
                                checked={(postData.disable_duet) ? true : false}
                                onChange={this.props.requestChange}
                                data-field={`postData.services.${this.props.serviceType}.disable_duet`}/>
                            <label htmlFor="tiktok-duet">Disable Duet</label>
                        </div>
                        <div className="pt-inline-checkbox">
                            <input
                                id="tiktok-stitch"
                                type="checkbox"
                                checked={(postData.disable_stitch) ? true : false}
                                onChange={this.props.requestChange}
                                data-field={`postData.services.${this.props.serviceType}.disable_stitch`}/>
                            <label htmlFor="tiktok-stitch">Disable Stitch</label>
                        </div>
                    </div>
                    <div className="pt-inline-toggles">
                        <ToggleControl
                            active={this.state.tikTokDisclosure}
                            labelPlacement="right"
                            activeLabel="Disclose Video Content"
                            inactiveLabel="Disclose Video Content"
                            toggleClass="pt-disclosure-toggle"
                            callback={this.toggleTikTokDisclosure}/>
                    </div>
                    {disclosureFields}
                </div>
            )
        }

        let youtubeFields = null;
        if (parseInt(this.props.serviceType) === constants.POST_SVC_YOUTUBE) {
            let categorySelector = null,
                categoryOptions = [],
                categoryValue = postData.category,
                hasTagError = false;

            if (Object.keys(this.props.socials.categories).length) {
                let keys = Object.keys(this.props.socials.categories);
                    categoryOptions = this.props.socials.categories[keys[0]];

                categorySelector = (
                    <div>
                        <div className="pt-field-label">{LabelLibrary.getStringsForField(this.props.serviceType, 'category', 'placeholder')}</div>
                        <StyledSelect
                            value={categoryValue}
                            linkedField={`postData.services.${this.props.serviceType}.category`}
                            onChange={this.props.requestChange}
                            options={categoryOptions}
                            selectClass="med pt"/>
                    </div>
                );
            }

            if (this.props.validationErrors[this.props.serviceType] !== undefined &&
                this.props.validationErrors[this.props.serviceType] &&
                this.props.validationErrors[this.props.serviceType].tags !== undefined &&
                this.props.validationErrors[this.props.serviceType].tags) {
                hasTagError = true;
            }

            /**
                
             */

            youtubeFields = (
                <div>
                    <div className="pt-service-field">
                        {categorySelector}
                    </div>
                    <div className="pt-service-field">
                        <div className="pt-field-label">{LabelLibrary.getStringsForField(this.props.serviceType, 'playlists', 'placeholder')}</div>
                        <YouTubePlaylistChooser
                            {...this.props}
                            onChange={this.props.requestChange}
                            playLists={(postData.playLists !== undefined && postData.playLists) ? postData.playLists : []}
                            field={`postData.services.${this.props.serviceType}.playLists`}/>
                    </div>
                    <div className="pt-service-field">
                        <div className="pt-inline-checkboxes">
                            <div className="pt-inline-checkbox">
                                <input
                                    id="youtube-embeddable"
                                    type="checkbox"
                                    checked={(postData.embeddable) ? true : false}
                                    onChange={this.props.requestChange}
                                    data-field={`postData.services.${this.props.serviceType}.embeddable`}/>
                                <label htmlFor="youtube-embeddable">Embeddable</label>
                            </div>
                            <div className="pt-inline-checkbox">
                                <input
                                    id="youtube-mfk"
                                    type="checkbox"
                                    checked={(postData.made_for_kids) ? true : false}
                                    onChange={this.props.requestChange}
                                    data-field={`postData.services.${this.props.serviceType}.made_for_kids`}/>
                                <label htmlFor="youtube-mfk">Made For Kids</label>
                            </div>
                            <div className="pt-inline-checkbox">
                                <input
                                    id="youtube-notifysubs"
                                    type="checkbox"
                                    checked={(postData.notify_subs) ? true : false}
                                    onChange={this.props.requestChange}
                                    data-field={`postData.services.${this.props.serviceType}.notify_subs`}/>
                                <label htmlFor="youtube-notifysubs">Notify Subscribers</label>
                            </div>
                        </div>
                    </div>
                    <div className="pt-service-field">
                        <ToggleControl
                            active={postData.postAsShort ? true : false}
                            labelPlacement="right"
                            activeLabel="Post as Short"
                            inactiveLabel="Post as Short"
                            toggleClass="pt-disclosure-toggle"
                            data-field={`postData.services.${this.props.serviceType}.postAsShort`}
                            callback={this.props.requestChange}/>
                        <div className="pt-tiktok-legal">
                            Shorts are limited to 3 minutes or less in length and may be modified for vertical playback.
                        </div>
                    </div>
                    <div className="pt-service-field">
                        <TagInput
                            {...this.props}
                            tags={postData.tags}
                            hasTagError={hasTagError}
                            updateTags={(tags) => {
                                let tagEvent = {
                                    currentTarget: {
                                        dataset: {
                                            field: `postData.services.${this.props.serviceType}.tags`
                                        }
                                    },
                                    target: {
                                        value: tags
                                    }
                                }

                                this.props.requestChange(tagEvent);
                            }}/>
                    </div>
                </div>
            )
        }

        let storyReelFields = null;
        if (parseInt(this.props.serviceType) === constants.POST_SVC_INSTAGRAM_BUSINESS) {
            storyReelFields = (
                <div className="pt-inline-toggles">
                    <ToggleControl
                        active={postData.publishAsStory ? true : false}
                        labelPlacement="right"
                        activeLabel="Publish as Story"
                        inactiveLabel="Publish as Story"
                        toggleClass="pt-disclosure-toggle"
                        data-field={`postData.services.${this.props.serviceType}.publishAsStory`}
                        callback={this.props.requestChange}/>
                </div>
            );
        }

        if (parseInt(this.props.serviceType) === constants.POST_SVC_FACEBOOK) {
            storyReelFields = (
                <div className="pt-inline-toggles">
                    <ToggleControl
                        controlState={!this.mediaChecker(['image', 'video']) ? 'disabled' : ''}
                        active={postData.publishAsStory ? true : false}
                        labelPlacement="right"
                        activeLabel="Publish as Story"
                        inactiveLabel="Publish as Story"
                        toggleClass="pt-disclosure-toggle"
                        data-field={`postData.services.${this.props.serviceType}.publishAsStory`}
                        callback={this.toggleFacebookMediaOptions}/>
                    <ToggleControl
                        controlState={!this.mediaChecker(['video']) ? 'disabled' : ''}
                        active={postData.publishAsReel ? true : false}
                        labelPlacement="right"
                        activeLabel="Publish as Reel"
                        inactiveLabel="Publish as Reel"
                        toggleClass="pt-disclosure-toggle"
                        data-field={`postData.services.${this.props.serviceType}.publishAsReel`}
                        callback={this.toggleFacebookMediaOptions}/>
                </div>
            )
        }

        let headerIcon = (
            <ServiceIcon
                round={true}/>
        );
        if (['edit-queue', 'edit-everqueue'].indexOf(this.props.editMode) !== -1) {
            let social = this.props.socials.list.find(({id}) => { return id === this.props.selectedSocials[this.props.serviceType][0]; })
            if (social) {
                headerIcon = (
                    <div className="pt-social-button-wrapper">
                        <PostSocialButton
                            {...this.props}
                            social={social}
                            isActive={true}
                            onClick={() => {}}
                            calculateLeft={true}/>
                    </div>
                );
            }
        }

        return (
            <div className="pt-service-fields">
                <div className="pt-service-header">
                    {headerIcon}
                    {headerFields}
                </div>
                {fieldOrder.map((key) => {
                    if (formFields.indexOf(key) !== -1) {
                        return (
                            <div className="pt-service-field" key={`service-field-${key}`}>
                                {this.fieldGenerator(key)}
                            </div>
                        );
                    }
                })}
                {tikTokFields}
                {youtubeFields}
                {storyReelFields}
                {linkPreview}
                {infoDisplay}
                {apiErrorDisplay}
                {errorDisplay}
            </div>
        );
    }
}

ServiceFields.displayName = "ServiceFields";

ServiceFields.propTypes = {
    serviceId: PropTypes.number,
    serviceValidator: PropTypes.object,
    sharedData: PropTypes.object
};

ServiceFields.defaultProps = {
    serviceId: 0,
    serviceValidator: {
        fields: [],
        forms: []
    },
    sharedData: {
        text: '',
        link: '',
        mb_id: ''
    }
};

export default ServiceFields;
